import React from 'react';
import useGetList from 'Hooks/query-hooks/list/useGetList';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import CreateAdvancedRuleLayout from './CreateAdvancedRuleLayout';

const CreateAdvancedRulePage = () => {
    const { users } = useGetReduxUsers();
    const parametersAPI = useGetParameters({
        queryParams: { status: JSON.stringify(['active']) }
    });
    const listsAPI = useGetList(users);
    const { hasError, errorCmp } = errorController([parametersAPI.error, listsAPI.error]);

    if (hasError) return <>{errorCmp}</>;
    if (parametersAPI.isLoading || parametersAPI.isFetching || listsAPI.isFetching || listsAPI.isLoading)
        return <RouteLoading />;

    return <CreateAdvancedRuleLayout parameterData={parametersAPI.data!} listData={listsAPI.data!} mode='add' />;
};

export default CreateAdvancedRulePage;
